import type { ElementType, ReactNode } from 'react';
import { cx } from '@/lib/cx';
import styles from './Container.module.css';

export type ContainerWidth = 'narrow' | 'default' | 'wide' | 'full';

export interface ContainerProps {
  children: ReactNode;
  /** narrow 704px · default 1200px · wide 1440px · full sin limite. */
  width?: ContainerWidth;
  /** Etiqueta HTML real. Por defecto `div`; usa `header`/`nav`/... si aporta semantica. */
  as?: ElementType;
  className?: string;
}

/**
 * Caja de contenido con el gutter fluido del sistema. Es el UNICO sitio donde
 * se decide el ancho maximo: ninguna seccion pone `max-width` a mano.
 */
export function Container({ children, width = 'default', as: Tag = 'div', className }: ContainerProps) {
  return <Tag className={cx(styles.container, styles[width], className)}>{children}</Tag>;
}
